import React from 'react'
import DashboardMetricItem from '@components/pages/Dashboard/DashboardMetricItem.component'
import { metricDataToItemProps } from '@utils/dashboardMetrics.util'
import type { DashboardMetricItemData } from '../../../../types/dashboardMetrics.types'
import './DashboardMetricTileGrid.style.css'

const TILE_CLASS = 'dashboard-metric-tile-box dashboard-metric-item'

export function DashboardMetricTile({
  metric,
}: {
  metric: DashboardMetricItemData
}): React.ReactElement {
  const props = metricDataToItemProps(metric)
  return (
    <DashboardMetricItem
      {...props}
      className={[TILE_CLASS, props.className].filter(Boolean).join(' ')}
    />
  )
}

type DashboardMetricTileGridProps = {
  metrics: DashboardMetricItemData[]
  columns?: 2 | 3 | 4 | 5 | 6 | 7
  className?: string
}

export function DashboardMetricTileGrid({
  metrics,
  columns = 3,
  className = '',
}: DashboardMetricTileGridProps): React.ReactElement {
  return (
    <div
      className={`dashboard-metric-tile-grid dashboard-metric-tile-grid--cols-${columns} ${className}`.trim()}
    >
      {metrics.map((m) => (
        <DashboardMetricTile key={m.id ?? m.leftLabel} metric={m} />
      ))}
    </div>
  )
}

export function pickMetricsByIds(
  items: DashboardMetricItemData[],
  ids: string[],
): DashboardMetricItemData[] {
  return ids.flatMap((id) => {
    const metric = items.find((m) => m.id === id)
    return metric ? [metric] : []
  })
}
